
<div class="d-flex flex-column justify-content-center align-items-center h-100">
  <p class="not-mobile message"
     [class.search-message]="filter === 'Search' || filter === 'Range'">{{ getMessage()?.replace('\n', ' ') }}</p>
  <p class="only-mobile message"
     [class.search-message]="filter === 'Search' || filter === 'Range'">{{ getMessage() }}</p>
</div>